import { MIN_MAX_VALUES } from 'pages/avia/filter/filter-search-screen/components'

import { FilterTicketForm } from 'entities/ticket/models/find-ticket/models'

import { simpleIsEqual } from 'shared/lib/simpleIsEqual'

const isDurationChanged = (filter: FilterTicketForm | undefined): boolean => {
  if (!filter?.durationOfTransfers) return false

  const currentDuration = {
    min: filter.durationOfTransfers.min_duration,
    max: filter.durationOfTransfers.max_duration,
  }

  return !simpleIsEqual(currentDuration, MIN_MAX_VALUES)
}

const isPriceChanged = (
  filter: FilterTicketForm | undefined,
  filterDataFromRequest: any,
): boolean => {
  if (!filter?.rangePrice || !filterDataFromRequest?.priceRange) return false

  const currentPrice = {
    min: parseInt(String(filter.rangePrice.min)) || 0,
    max: parseInt(String(filter.rangePrice.max)) || 0,
  }

  const defaultPrice = {
    min: parseInt(filterDataFromRequest.priceRange.min) || 0,
    max: parseInt(filterDataFromRequest.priceRange.max) || 0,
  }

  return !simpleIsEqual(currentPrice, defaultPrice)
}

const hasTransferConditions = (
  filter: FilterTicketForm | undefined,
): boolean => {
  return Boolean(
    filter?.isWithChangeAirport ||
    filter?.isWithRepeatRegistration ||
    filter?.isWithNightTransition,
  )
}

const isTimeFilterActive = (filter: FilterTicketForm | undefined): boolean => {
  if (!filter?.time || filter.time.length === 0) return false

  return filter.time.some((item) => {
    const hasDeparture = item.departure
      ? Array.isArray(item.departure)
        ? item.departure.length > 0
        : Boolean(item.departure.from || item.departure.to)
      : false

    const hasArrival = item.arrival
      ? Array.isArray(item.arrival)
        ? item.arrival.length > 0
        : Boolean(item.arrival.from || item.arrival.to)
      : false

    return hasDeparture || hasArrival
  })
}

export const getFilterActiveState = (
  filter: FilterTicketForm | undefined,
  filterDataFromRequest: any,
) => {
  return {
    airlines: Boolean(filter?.airlines?.length),
    transfers: isDurationChanged(filter) || hasTransferConditions(filter),
    price: isPriceChanged(filter, filterDataFromRequest),
    time: isTimeFilterActive(filter),
  }
}
